'use client';

import type { FC } from 'react';
import { createPortal } from 'react-dom';

import type { ToastProviderPortalPropsInterface } from './types/toast-provider-portal.types';

/**
 * ToastProvider.Portal creates a portal to house the Toast list
 */
export const ToastProviderPortal: FC<ToastProviderPortalPropsInterface> = (props) => {
  const { children, portal = true } = props;

  if (portal === true && typeof window !== 'undefined') {
    return createPortal(children, document.body);
  }

  if (portal !== true && portal) {
    return createPortal(children, portal);
  }

  return children;
};

ToastProviderPortal.displayName = 'ToastProvider.Portal';
